class Registry {
    _store;

    constructor() {
        this._store = {};
    }

    get(key) {
        if (this._store.hasOwnProperty(key)) {
            return this._store[key];
        } else {
            console.error(key + " not found in registry");
        }
    }

    set(key, value) {
        this._store[key] = value;
    }

    hasKey(key) {
        return this._store.hasOwnProperty(key);
    }

    getReport() {
        return this._store;
    }
}

//export default Registry;
module.exports = {
    Registry
};
